import { UserListUsersByCourse, UserLessonPublish, UserLessonUpdateAttendance } from './Request';
import graphql from './graphql';

export const userLessonUserList = async ({ courseId, lessonId }) => {
  const promises = [];
  promises.push(UserListUsersByCourse({ courseId, lessonId }));
  promises.push(graphql('Department_list', 'name', 'query'));
  promises.push(graphql('Terminal_list', 'name', 'query'));
  promises.push(graphql('JobTitle_list', 'name', 'query'));

  const response = await Promise.all(promises);

  const fetchedUsers = response[0];
  const users = [];

  let index = 0;

  fetchedUsers.forEach(data => {
    const user = data.User;
    users.push([
      user.fullName,
      user.JobTitle.name,
      user.Department.name,
      user.Terminal.name,
      user?.UserLessons?.attended || false,
      user.id,
      user?.UserLessons?.id,
      index,
      user?.UserLessons?.isDraft,
    ]);
    index += 1;
  });

  const mapDeparment = data => data.map(department => department.name);
  const departments = mapDeparment(response[1].Department_list);

  const mapTerminal = data => data.map(terminal => terminal.name);
  const terminals = mapTerminal(response[2].Terminal_list);

  const mapJobTitle = data => data.map(jobTitle => jobTitle.name);
  const jobTitles = mapJobTitle(response[3].JobTitle_list);

  return { users, departments, terminals, jobTitles };
};

export const userLessonSave = async ({ lessonId, userAttendance }) =>
  UserLessonUpdateAttendance({
    lessonId,
    userAttendance,
  });

export const userLessonPublish = async ({ lessonId }) => {
  const response = await UserLessonPublish({ lessonId });
  return response;
};

export default {
  userLessonUserList,
  userLessonSave,
  userLessonPublish,
};
